<template>
  <div class="yCenter" v-if="platformList">
    <div :style="{ width: getWidth('uploadedDate') }" class="colStyle px-1">
      {{ getDate(items.createdAt) }}
    </div>
    <div :style="{ width: getWidth('shopName') }" class="colStyle px-1">
      {{ getPlatformName(items.platformId) }}
    </div>
    <div :style="{ width: getWidth('userId') }" class="colStyle px-1">
      {{ items.user.lastName }}
    </div>
    <div :style="{ width: getWidth('exCsvFileNumber') }" class="colStyle px-1">
      {{ items.exCsvFileNumber }}
    </div>

    <!-- ステータス -->
    <div class="yCenter">
      <span class="yCenter operationAreaStyle">
        <span class="statusNameStyle">
          {{
            items.status == 99
              ? $t('order.order_invalid')
              : $t('common.common_normal')
          }}
        </span>
        <NormalButton
          text="common.common_invalid"
          class="mr-2"
          btnClass="pa-2"
          width="70px"
          height="32px"
          color="white"
          textColor="thinText--text"
          :outlined="true"
          :disabled="items.status == 99"
          @click="onclickInvalidate"
        />
      </span>
    </div>

    <NormalButton
      text="ship.ship_ship-request"
      class="mr-2"
      btnClass="pa-2"
      width="70px"
      height="32px"
      @click="onClickDeliveryRequest"
    />
    <NormalButton
      text="sale.sale_sale-register"
      btnClass="pa-2"
      width="70px"
      height="32px"
      @click="onClickSalesRegistration"
    />

    <ShipRequestDialog
      v-model="deliveryRequest"
      :list="selectedList"
      :shopName="getPlatformName(items.platformId)"
      :platformId="items.platformId"
    />
    <SalesRegistrationDialog
      v-model="salesRegistration"
      :list="selectedList"
      :platformId="items.platformId"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import NormalButton from '@/components/items/Buttons/NormalButton'
import {
  ShipRequestDialog,
  SalesRegistrationDialog
} from '@/components/layouts/Dialogs/Csv'
import { commonUtil, platformUtil } from '@/util'

export default {
  components: {
    NormalButton,
    ShipRequestDialog,
    SalesRegistrationDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  data: () => ({
    deliveryRequest: {
      dialog: false
    },
    salesRegistration: {
      dialog: false
    },
    platformList: null
  }),
  computed: {
    selectedList() {
      return this.items.exCsvFileDetailList.filter((item) => item.isCheck)
    }
  },
  methods: {
    ...mapActions('FileStore', ['externalSystemCsvInvalidate']),
    ...mapActions('Platform', ['getPlatformListFromApi']),
    async init() {
      this.platformList = await this.getPlatformListFromApi()
    },
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getDate(dateTime) {
      return commonUtil.getDateFromDateTimeString(dateTime)
    },
    onClickDeliveryRequest() {
      if (this.selectedList.length === 0) {
        alert(this.$t('common.common_data-not-selected'))
        return
      }
      this.deliveryRequest.dialog = true
    },
    getPlatformName(platformId) {
      return platformUtil.getPlatformById(platformId).name
    },
    onClickSalesRegistration() {
      if (this.selectedList.length === 0) {
        alert(this.$t('common.common_data-not-selected'))
        return
      }
      this.salesRegistration.dialog = true
    },
    async onclickInvalidate() {
      if (!confirm(this.$t('common.common_disable-question'))) return

      const isSuccess = await this.externalSystemCsvInvalidate({
        id: this.items.exCsvFileId
      })
      if (!isSuccess) return
      alert(this.$t('common.common_disabled'))
      this.$emit('pageReload')
    }
  },
  async created() {
    await this.init()
  }
}
</script>

<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.operationAreaStyle {
  width: 120px;
}
.statusNameStyle {
  width: 36px;
}
</style>
